<template>
  <div id="content" v-if="loaded">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging" v-if="!idContentSource">
          <router-link :to="{ name: moduleName }"  class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat okno údržby ke zdroji obsahu</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-if="!idContentSource">
            <div class="left">
              <h2 v-translate>Zdroj obsahu</h2>
            </div>
            <div class="right checkbox_group" v-for="(item, key) in localities">
              <SelectContentSource
                  :id-locality="Number(key)"
                  :locality-name="item['name']"
                  :content-sources="item['content_sources']"
                  :key="'select_content_source_'+key"
                  @input="onContentSourceChange"
              />
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Nastavení</h2>
            </div>
            <div class="right">
            <div class="field_left">
              <date-picker edit-time
                           id="time_start"
                           date-format="d. m. yy"
                           attrKey="start"
                           v-model="entity.start"
                           @update-date="updateDate"
              >
                <translate class="translate">Údržba od *</translate>
              </date-picker>
            </div>
            <div class="field_right">
              <date-picker edit-time
                           id="time_end"
                           date-format="d. m. yy"
                           attrKey="end"
                           v-model="entity.end"
                           @update-date="updateDate"
              >
                <translate class="translate">Údržba do *</translate>
              </date-picker>
            </div>
              <div class="field_left">
                <text-input
                    id="description"
                    v-model="entity.description"
                >
                  <translate class="translate">Poznámka</translate>
                </text-input>
              </div>
            </div>
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" v-if="!idContentSource"  class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input v-if="!idContentSource"
                  type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity(true)">
              <input v-else
                  type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity(false,{
                       path: 'contentSourceDetail',
                       params: {id: idContentSource}
                     })">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import SelectContentSource from "./SelectContentSource.vue";
import detailActions from "@/components/mixins/detail-actions"
import contentSourceMaintenanceWindow from "./mixins/contentSourceMaintenanceWindow"

export default {
  name: "ContentSourceMaintenanceWindowNew",
  components: {
    SelectContentSource
  },
  mixins: [
    contentSourceMaintenanceWindow,
    detailActions,
  ],
  data() {
    return {
      loaded: false,
      selectedContentSources: {},
      moduleName: 'contentSourceMaintenanceWindows',
      entity: {
        id_content_sources: [],
        start: null,
        end: null,
        description: ""
      },
      datetimeFields: [
        'start',
        'end',
      ],
      updateFields: [
          'id_content_sources',
          'start',
          'end',
          'description'
      ],
    }
  },
  created(ContentSourceMaintenanceWindowService, LocalityService) {
    this.entityService = ContentSourceMaintenanceWindowService;
    this.localityService = LocalityService;

    if(this.idContentSource){
      this.entity.id_content_sources = [this.idContentSource];
      this.loaded = true;
    }else {
      this.localityService.getLocalitiesWithContentSourcesSimple()
          .then((data) => {
            this.localitiesData = data.localities;
            this.loaded = true;
          });
    }
  },
  computed: {
    localities() {
      return this.localitiesData
    },
    idContentSource(){
      if(this.$route.params.hasOwnProperty('idContentSource') && this.$route.params.idContentSource){
        return this.$route.params.idContentSource
      }else{
        return null;
      }
    }
  },
  methods: {
    onContentSourceChange(idLocality, selectedItems){
      this.selectedContentSources[idLocality] = selectedItems;

      this.entity.id_content_sources = [];
      Object.values(this.selectedContentSources).forEach(item => {
        this.entity.id_content_sources = this.entity.id_content_sources.concat(item);
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowNew.vue